import { createFileRoute } from '@tanstack/react-router'
import GlobePage from '@/features/globe/GlobePage'

/**
 * Dashboard landing → the native maplibre-gl globe (react-map-gl) with Esri
 * World Imagery, phenom event markers, and metadata-driven media-view
 * recreation (cameraFromEvent -> flyTo). Replaces the Cesium globe (retired;
 * SitRec removed on licensing). The old Cesium `Globe.tsx`/`CesiumGlobe`
 * remain in-tree as reference pending cleanup.
 */
export const Route = createFileRoute('/_authenticated/')({
  component: GlobePage,
})
